import serverCall from '../../modules/serverCall'

const americasQuery = {
  greaterRegions: ['Americas'],
  regions: [],
  markets: [],
  periods: [],
  isGlobal: null
};

export const getAllMarkets =() =>dispatch=> {
  dispatch({
    type:GET_ALL_MARKETS_BEGIN,
  })
  return serverCall({
    method:'POST',
    url:`/RentCycleData/Search` ,
    data: americasQuery
  })
  .then(res=>{
    dispatch({
      type: GET_ALL_MARKETS_SUCCESS,
      payload: res
    })
    return res
  })
  .catch(error=>{
    dispatch({
      type: GET_ALL_MARKETS_FAIL,
      payload: {error}
    })
    return error
  })
}


export const GET_ALL_MARKETS_BEGIN='GET_ALL_MARKETS_BEGIN'
export const GET_ALL_MARKETS_SUCCESS='GET_ALL_MARKETS_SUCCESS'
export const GET_ALL_MARKETS_FAIL='GET_ALL_MARKETS_FAIL'
